import { gql } from '@apollo/client'
import fullOneOffPaymentFragment from './fullOneOffPayment.fragment'

const CreateOrUpdateOneOffPayment = gql`
  mutation createOrUpdateOneOffPayment($oneOffPayment: OneOffPaymentInput!) {
    createOrUpdateOneOffPayment(oneOffPayment: $oneOffPayment) {
      ...FullOneOffPayment
    }
  }
  ${fullOneOffPaymentFragment}
`

const DeleteOneOffPayment = gql`
  mutation deleteOneOffPayment($oneOffPaymentId: HashedId!) {
    deleteOneOffPayment(oneOffPaymentId: $oneOffPaymentId)
  }
`
export default {
  CreateOrUpdateOneOffPayment,
  DeleteOneOffPayment,
}
